
angular.module('admin')

.directive('saveElementHeight', function($rootScope, $timeout) {
    return function(scope, element, attrs) {
    	$rootScope.elementHeight = $rootScope.elementHeight || {};
    	var updateTimeout = null;
		var update = function(){
			//$rootScope.elementHeight[attrs.saveElementHeight] = element.is(':visible')? element.outerHeight(true) : 0;
			if (element.hasClass('ng-hide') || element.closest('.ng-hide').length) {
				// elementy ukryte przez angular
				$rootScope.elementHeight[attrs.saveElementHeight] = 0;
			} else if (element.is(':visible')) {  // sprawdzanie, czy element jest w DOM (casem nie jest nie wiedzieć czemu i height => 0)
				$rootScope.elementHeight[attrs.saveElementHeight] = element.outerHeight();
			}
			$rootScope.elementHeight['window'] = $(window).height();
			$rootScope.elementHeight['$max'] = Math.max;
			$rootScope.elementHeight['$min'] = Math.min;
		}
		var applyUpdate = function (){$timeout.cancel(updateTimeout); updateTimeout = $timeout(update);}
		angular.element(window).bind('resize', applyUpdate);  // update on window resize
		angular.element(window).bind('click', function(){/*update();*/applyUpdate()});  // update on click
		//scope.$watch(update);                                 // update every digest
		update();                                             // update now
		//$interval(update, 500);
	}
})

.directive('setElementHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return scope.$eval(attrs.setElementHeight, $rootScope.elementHeight);
    	}
    	$rootScope.$watch(evalHeight, function(h) {
    		if (h !== null) {
    			element.height(h);
    			//element.css({minHeight: h});
    		}
    	});
	}
})

.directive('setElementMinHeight', function($rootScope) {
    return function(scope, element, attrs) {
    	var evalHeight = function() {
    		return scope.$eval(attrs.setElementMinHeight, $rootScope.elementHeight);
    	}
    	$rootScope.$watch(evalHeight, function(h) {
    		if (h !== null) {
    			element.css({minHeight: h});
    		}
    	});
	}
})

.directive('checkNavButtonCollapse', function($timeout) {
	return {
		restrict: 'A',
        link: function(scope, element, attrs){
			var last_nav_options_collapse_width = 0;
			var do_collapse = false;
			var checkCollapse = function(){

				// container width
				var nav_container_width = element.width();
				
				// all btns width
				if (!do_collapse) {
					var nav_options_width = 0;
					angular.forEach(element.find('li'), function(value, key) {
						nav_options_width += $(value).outerWidth(true);
					});
				} else {
					nav_options_width = last_nav_options_collapse_width;
				}
				
				if(nav_container_width <= nav_options_width){
					last_nav_options_collapse_width = nav_options_width;
					do_collapse = true;
				}else{
					do_collapse = nav_container_width < last_nav_options_collapse_width
				}
				return do_collapse;
			}
			var update = function() {
				scope[attrs.collapse] = checkCollapse();
			}
			var updateTimeout = null;
			var applyUpdate = function (){$timeout.cancel(updateTimeout); updateTimeout = $timeout(update);}
        	angular.element(window).bind('resize', applyUpdate);  // update on window resize
			angular.element(window).bind('click', function(){applyUpdate()});  // update on click
			updateTimeout = $timeout(update); 

        }//link

    };//return
})

